import React from "react";
import { connect } from "react-redux";
import {
  selectRestaurantFromMap,
  unselectRestaurant,
} from "../../actions/restaurants";
import useEvent from "../../hooks/useEvent";
import { getLeafRating } from "../../util/leafRating";
import { getAnalyticsSource } from "../../util/analytics";
import LeafRating from "../common/LeafRating";
import greenv from "./green-v-md.png";

const MapMarker = (props) => {
  const {
    restaurant,
    hover,
    selected,
    selectRestaurantFromMap,
    unselectRestaurant,
    text,
    showLabel,
  } = props;
  const eventContext = useEvent();

  const className = `${selected || hover ? "selected" : ""}`;
  const onClick = !selected
    ? () => {
        // Pass eventContext to action, which will handle analytics logging
        selectRestaurantFromMap(restaurant._id, eventContext, getAnalyticsSource(restaurant));
      }
    : () => unselectRestaurant();

  // Get leaf rating for label display
  const rating = getLeafRating(restaurant);

  return (
    <div onClick={onClick} style={{ width: 0, height: 0, overflow: 'visible' }}>
      <img
        key={restaurant._id}
        title={restaurant.name}
        name={restaurant.name}
        src={greenv}
        alt={text}
        width="32"
        className={`map-marker-offset ${className}`}
      />
      {(showLabel || selected) && (
        <div className="map-marker-tag">
          <span className="map-marker-name">{text}</span>
          {!eventContext?.event && (
            <>
              <span className="map-marker-separator">·</span>
              <span className="map-marker-leaves">
                <LeafRating count={rating.count} tier={rating.tier} showTooltip={false} />
              </span>
            </>
          )}
          <br />
          {restaurant.cuisine
            .filter(Boolean)
            .map((string) => string.replace(/\b\w/g, (l) => l.toUpperCase()))
            .join(", ")}
        </div>
      )}
    </div>
  );
};
// export default GoogleApiWrapper({
//   apiKey: 'AIzaSyCHTvWtg42OxUZ6oyN0YeM0Oyy8oCRHFxs'
// })(MapMarker);
const mapStateToProps = (state, props) => ({
  hover:
    !state.restaurant.selected &&
    state.restaurant.hover === props.restaurant._id,
  selected: state.restaurant.selected === props.restaurant._id,
});
export default connect(mapStateToProps, {
  selectRestaurantFromMap,
  unselectRestaurant,
})(MapMarker);
